import React from "react";
import { Layer, Marker, Source } from "react-map-gl/mapbox";
import * as turf from "@turf/turf";

const GpsPolygon = ({ name, id, colour, coordinates_polygon, showLabel=true }) => {
  const toRing = (coords) => {
    if (!coords || !Array.isArray(coords) || coords.length < 3) return null;
    let ring;
    ring = coords.map((v) => [Number(v.longitude), Number(v.latitude)]);
    return ring;
  };

  const geofence = toRing(coordinates_polygon);
  if (!geofence) return null;

  const polygonGeoJSON = {
    type: "Feature",
    properties: { id: String(id), name },
    geometry: {
      type: "Polygon",
      coordinates: [geofence],
    },
  };

  const centroidGeofence = turf.centroid(polygonGeoJSON); 


  const sourceId = `polygon-source-${String(id)}`;
  const fillLayerId = `polygon-fill-${String(id)}`;
  const lineLayerId = `polygon-line-${String(id)}`;
  const labelLayerId = `polygon-label-${String(id)}`;

  const fillLayer = {
    id: fillLayerId,
    type: "fill",
    paint: {
      "fill-color": colour || "#00A",
      "fill-opacity": 0.3,
    },
  };

  const lineLayer = {
    id: lineLayerId,
    type: "line",
    paint: {
      "line-color": colour || "#00A",
      "line-opacity": 0.7,
      "line-width": 2,
    },
  };

  const labelLayer = {
    id: labelLayerId,
    type: "symbol",
    layout: {
      "text-field": ["get", "name"], // toma la propiedad "name"
      "text-size": 14,
      "text-anchor": "center",
    },
    paint: {
      "text-color": "#000",
      "text-halo-color": "#fff", // borde blanco para que no se pierda
      "text-halo-width": 2,
    },
  };

  return (
    <Source id={sourceId} type="geojson" data={polygonGeoJSON}>
      <Layer {...fillLayer} />
      <Layer {...lineLayer} />
      {showLabel && (
        <Marker
        key={name}
        longitude={centroidGeofence.geometry.coordinates[0]}
        latitude={centroidGeofence.geometry.coordinates[1]}
        
      >
        <div className="w-17 text-[9px] text-center bg-white bg-opacity-60 text-black rounded shadow px-1 py-1">
          {name}
        </div>
      </Marker>
      )}
    </Source>
  );
};

export default GpsPolygon;
